/**
 * App instalável (PWA): registra o /sw.js mínimo — sem cache, a aba velha continua sendo
 * detectada pelo /version.json (RC-063). `updateViaCache: 'none'` faz o navegador sempre
 * buscar o sw.js novo na rede.
 */
export function registerServiceWorker(nav: Navigator = navigator, isProduction = import.meta.env.PROD): void {
  if (!isProduction || !('serviceWorker' in nav)) return;
  window.addEventListener('load', () => {
    nav.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch(() => undefined);
  });
}
